declare var HubSpotConversations: any;

import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { StateService, UIRouterGlobals } from "@uirouter/core";
import { environment as appEnv } from "../../environments/environment";
import { FeatureFlagService } from "../feature-flag/feature-flag.service";
import { GetStartedModalService } from "../get-started-modal/get-started-modal.service";
import { NotifierPropertiesService } from "../models/notifier-properties.service";
import { PlanTierService } from "../plan-tier/plan-tier.service";
import { InstructionsModalService } from "../project-detail/instructions-modal/instructions-modal.service";
import { RememberService } from "../remember/remember.service";
import { SendDataModalService } from "../send-data-modal/send-data-modal.service";
import { TimeDurAgoService } from "../time-dur-ago/time-dur-ago.service";
import { UpgradeModalService } from "../upgrade-modal/upgrade-modal.service";

@Component({
  selector: "ab-project-performance",
  templateUrl: "./project-performance.component.html",
})
export class ProjectPerformanceComponent implements OnInit {
  @Input() public project: any;
  @Input() public user: any;
  @Input() public emptyProject: boolean;

  public appEnv = appEnv;
  public timeDurSwitchEnabled: boolean;
  public dur: string;
  public lastN: string | number;
  public requestMethod: string;
  public timeDurAgo: string;
  public environment: string;
  public showRouteTable: boolean;
  public showQueryList: boolean;
  public notifierName: any;
  public notifierLanguage: any;
  public installedNotifier: boolean;
  public featureDisabled: boolean;
  public queryPage: number;
  public sortQueryColumn: string;
  public sortQueryDesc: boolean;
  public routeSearch: string;
  public querySearch: string;
  public queueSearch: string;
  public currentTab: string;
  public queuePage: number;
  public sortQueueColumn: string;
  public sortQueueDesc: boolean;

  private REMEMBER_DURATION_KEY = "projectPerformance.duration";
  private REMEMBER_LAST_N_KEY = "projectPerformance.lastN";
  private loadingComponents: number;

  constructor(
    private $state: StateService,
    private $uiRouterGlobals: UIRouterGlobals,
    private changeDetector: ChangeDetectorRef,
    private getStartedModalService: GetStartedModalService,
    private instructionsModalService: InstructionsModalService,
    private notifierPropertiesService: NotifierPropertiesService,
    private planTierService: PlanTierService,
    private rememberService: RememberService,
    private sendDataModalService: SendDataModalService,
    private timeDurAgoService: TimeDurAgoService,
    private upgradeModal: UpgradeModalService,
    private featureFlagService: FeatureFlagService,
  ) {}

  public ngOnInit() {
    this.planTierService.features().subscribe((features: any) => {
      this.featureDisabled = !features.performance_dashboard;
      if (this.featureDisabled) {
        this.dur = "90d/1d";
        this.lastN = 90;
      }
    });
    window.document.title = `${this.project.name} performance`;
    this.loadingComponents = 0;
    this.timeDurSwitchEnabled = false;

    this.dur =
      this.$uiRouterGlobals.params.dur ||
      this.rememberService.get(this.REMEMBER_DURATION_KEY, "90d/1d");
    this.lastN =
      this.$uiRouterGlobals.params.last_n ||
      Number(this.rememberService.get(this.REMEMBER_LAST_N_KEY, "90"));
    this.requestMethod = this.$uiRouterGlobals.params.method;
    this.timeDurAgo = this.timeDurAgoService.timeFor(this.dur, this.lastN);
    this.queryPage = this.$uiRouterGlobals.params.queryPage;
    this.sortQueryColumn = this.$uiRouterGlobals.params.sortQueryColumn;
    this.sortQueryDesc = this.$uiRouterGlobals.params.sortQueryDesc;
    this.routeSearch = this.$uiRouterGlobals.params.routeSearch;
    this.querySearch = this.$uiRouterGlobals.params.querySearch;
    this.queueSearch = this.$uiRouterGlobals.params.queueSearch;
    this.currentTab = this.$uiRouterGlobals.params.currentTab;
    this.queuePage = this.$uiRouterGlobals.params.queuePage;
    this.sortQueueColumn = this.$uiRouterGlobals.params.sortQueueColumn;
    this.sortQueueDesc = this.$uiRouterGlobals.params.sortQueueDesc;

    const params = { projectId: this.project.id };

    this.notifierPropertiesService.get(params).subscribe((props: any) => {
      this.notifierName = props.notifier_name;
      this.notifierLanguage = props.notifier_language;
      this.installedNotifier = props.installed_notifier;
    });

    this.showQueryList = this.featureFlagService.getexceptional();

    if (this.emptyProject && !this.sendingDemoData()) {
      this.modalService().open();
    }
  }

  public onTimeDurSwitchChange(params: any) {
    this.dur = params.dur;
    this.lastN = params.last_n;

    this.rememberService.set(this.REMEMBER_DURATION_KEY, params.dur);
    this.rememberService.set(this.REMEMBER_LAST_N_KEY, params.last_n);

    this.$state.go(this.$uiRouterGlobals.current.name, {
      dur: this.dur,
      last_n: this.lastN,
    });

    this.timeDurAgo = this.timeDurAgoService.timeFor(this.dur, this.lastN);
  }

  public onLoading(count: number) {
    this.loadingComponents += count;
    this.timeDurSwitchEnabled = this.loadingComponents === 0;
    this.changeDetector.detectChanges();
  }

  public onRequestMethodChange(requestMethod: string) {
    this.requestMethod = requestMethod;
    this.$state.go(this.$uiRouterGlobals.current.name, {
      method: requestMethod,
    });
  }

  public onRequestMethodDelete() {
    delete this.requestMethod;
    this.$state.go(this.$uiRouterGlobals.current.name, { method: null });
  }

  public onEnvironmentChange(environment: any) {
    this.environment = environment === "all" ? undefined : environment;
    this.showRouteTable = true;
    this.$state.go(this.$uiRouterGlobals.current.name, { environment });
  }

  public performanceFeedback() {
    HubSpotConversations.widget.open();
  }

  public openUpgradeModal($event: any) {
    this.upgradeModal.open($event);
  }

  public uiOnParamsChanged(newParams: { [paramName: string]: any }) {
    if (newParams.queryPage) {
      this.queryPage = newParams.queryPage;
    }

    if (newParams.sortQueryColumn) {
      this.sortQueryColumn = newParams.sortQueryColumn;
    }

    if (newParams.hasOwnProperty("sortQueryDesc")) {
      this.sortQueryDesc = newParams.sortQueryDesc;
    }

    if (newParams.hasOwnProperty("routeSearch")) {
      this.routeSearch = newParams.routeSearch;
    }

    if (newParams.hasOwnProperty("querySearch")) {
      this.querySearch = newParams.querySearch;
    }

    if (newParams.hasOwnProperty("queueSearch")) {
      this.queueSearch = newParams.queueSearch;
    }

    if (newParams.currentTab) {
      this.currentTab = newParams.currentTab;
    }

    if (newParams.queuePage) {
      this.queuePage = newParams.queuePage;
    }

    if (newParams.sortQueueColumn) {
      this.sortQueueColumn = newParams.sortQueueColumn;
    }

    if (newParams.hasOwnProperty("sortQueueDesc")) {
      this.sortQueueDesc = newParams.sortQueueDesc;
    }
  }

  private modalService() {
    if (
      this.project.isFirstProject &&
      !this.project.demoModeUntilDate &&
      !this.rememberService.get("sendDataModalDismissed")
    ) {
      return this.sendDataModalService;
    }

    if (this.rememberService.get("getStartedModalDismissed")) {
      return this.instructionsModalService;
    }

    return this.getStartedModalService;
  }

  private sendingDemoData(): boolean {
    if (!this.project.demoModeUntilDate) {
      return false;
    }

    return new Date() < new Date(this.project.demoModeUntilDate);
  }
}
